<template>
  <div v-if="text" v-html="text.text">
  </div>
</template>

<script>
export default {
  name: "VersionedText",
  props: ['text_type'],
  mounted() {
    axios.get('/api/text/latest/' + this.text_type)
        .then(response => {
          this.text = response.data
        })
        .catch(error => {
          console.log('could not load map')
        })
  },
  data() {
    return {
      text: null,
    }
  }
}
</script>

<style scoped>

</style>